// extracted by mini-css-extract-plugin
module.exports = {"auto_btn":"auto_btn-QnhOlI8N clearfix","btn0":"btn0-3b0x4Q9E","btn1":"btn1-10-F4o4K"};